import React from "react";
import "./style.scss";
import img1 from "../../../Assets/Images/main-list-img-1.png";
import img2 from "../../../Assets/Images/main-list-img-2.png";
import img3 from "../../../Assets/Images/main-list-img-3.png";
import img4 from "../../../Assets/Images/main-list-img-4.png";
import img5 from "../../../Assets/Images/main-list-img-5.png";
import img6 from "../../../Assets/Images/main-list-img-6.png";
import img7 from "../../../Assets/Images/main-list-img-7.png";
import img8 from "../../../Assets/Images/main-list-img-8.png";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const dataCareer = [
    { id: 0, img: img1, key: "productionTech" },
    { id: 1, img: img2, key: "graphicArt" },
    { id: 2, img: img3, key: "motionPlanner" },
    { id: 3, img: img4, key: "experienceDesign" },
    { id: 4, img: img5, key: "projectManagement" },
    { id: 5, img: img6, key: "spaceDesign" },
    { id: 6, img: img7, key: "constructionManagement", blackColor: true },
    { id: 7, img: img8, key: "more", blackColor: true },
];

function Career() {

    const { t } = useTranslation();

    return (
        <main className="career">
            <div className="title">{t("career.title")}</div>
            <ul className="menu">
                {dataCareer.map((item, index) => (
                    <li key={index} className="menu-item">
                        <Link to="/">
                            <img src={item.img} alt="" />
                            <div className="menu-item-content">
                                <div style={{ color: item.blackColor ? "#111" : "#fff" }} className="title-en">
                                    {t(`career.items.${item.key}`)}
                                </div>
                                {/* <div style={{ color: item.blackColor ? "#111" : "#fff" }} className="title-ko">
                                    {item.ko}
                                </div> */}
                            </div>
                        </Link>
                    </li>
                ))}
            </ul>
        </main>
    );
}

export default Career;
